import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { resetPaginationStores } from '@/std/pagination/createPaginationStore';
import type { LoginLogar } from './types/LoginLogar';
import { createLoginStorage } from './loginStorage';

type LoginStore = {
    acessoNegadoMessage: string | null;
    codigoVerificado: boolean;
    empresaIdpk: number | null;
    isFintech: boolean;
    login: LoginLogar | null;
    sessionId: string | null;
    renovandoToken: boolean;
};

const initialState: LoginStore = {
    acessoNegadoMessage: null,
    codigoVerificado: false,
    empresaIdpk: null,
    isFintech: false,
    login: null,
    renovandoToken: false,
    sessionId: null,
};

export const useLoginStore = create<LoginStore>()(
    persist(() => initialState, {
        name: 'login',
        partialize: (state) => ({
            empresaIdpk: state.empresaIdpk,
            isFintech: state.isFintech,
            login: state.login,
            sessionId: state.sessionId,
        }),
        storage: createJSONStorage(() =>
            createLoginStorage(window.localStorage, window.sessionStorage),
        ),
    }),
);

export function resetLoginStore(): void {
    resetPaginationStores();
    useLoginStore.setState({ ...initialState }, true);
}
